import { getBaseMetaTitle } from '@/environments'
const Winners = () => import('./Main')

const route = {
  path: '/winners',
  name: 'winners',
  meta: {
    title: `Winners - ${getBaseMetaTitle}`
  },
  component: Winners
}

export default route
